import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { MdDelete } from 'react-icons/md';
import { FaEdit } from 'react-icons/fa';
import { RiBroadcastFill } from 'react-icons/ri';
import { AiOutlinePlus } from 'react-icons/ai';
import { Link } from 'react-router-dom';
import { Tooltip } from '@mui/material';
import Paper from '@mui/material/Paper';
import { Modal } from 'antd';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import Select from 'react-select';
import styles from '../../assets/css/TogglerButton.module.css';
import {
  activateNotification, broadcastNotification, deleteNotification, notificationListView
} from '../../Services/Utils/NotificationApis';
import { notifySet } from '../../Services/Actions/CommonActions';
import { fromEpochToDate, isEmpty } from '../../Services/config/globals';
import { getImage } from '../../Services/Utils/FileApis';
import { serviceProviderList } from '../../Services/Utils/ServiceProviderApis';
import { UseStyles } from '../../components/TableStyles/tableSX';

function Toggler(props) {
  const dispatch = useDispatch();
  const { notificationData } = props;
  const [isNotificationActive, setIsNotificationActive] = useState(notificationData.active);

  const handlleNotificationActiveChange = (res) => {
    activateNotification({ id: res.id }).then((resp) => {
      if (resp.hasError === false) {
        dispatch(notifySet({ type: 'success', message: resp.message }));
        setIsNotificationActive(!isNotificationActive);
      } else if (resp.hasError === true) {
        dispatch(notifySet({ type: 'error', message: resp.message }));
      }
    });
  };
  return (
    <label className={styles.switch}>
      <input
        type="checkbox"
        id="Btn"
        className={`${styles['switch-input']}`}
        checked={isNotificationActive}
        onChange={() => handlleNotificationActiveChange(notificationData)}
      />
      <span className={`${styles.slider} ${styles['slider-round']}`} />
    </label>
  );
}

function NotificationList() {
  const dispatch = useDispatch();
  const classes = UseStyles();

  // table pagination
  const [page, setPage] = useState(0);
  const [rowsPerPage, setrowsPerPage] = useState(10);
  const [itemOffset, setItemOffset] = useState(0);
  const [listRecordSize, setListRecordSize] = useState(0);
  const onPageChange = (event, newPage) => {
    setPage(newPage);
    const newOffset = (newPage * rowsPerPage) % listRecordSize;
    setItemOffset(newOffset);
  };
  const handleChangeRowsPerPage = (event) => {
    setrowsPerPage(event.target.value);
  };

  // Service Partner dropdown
  const [serviceProviderOptionList, setServiceProviderOptionList] = useState();
  const [serviceProvider, setServiceProvider] = useState(0);

  const getServiceProviderDropDownList = () => {
    const data = {
      status: {
        id: 2,
      },
    };
    const params = {
      start: 0,
      recordSize: '',
    };
    serviceProviderList(data, params).then(async (res) => {
      const { list, hasError } = res;
      const categoryList = [];
      if (hasError === false) {
        list.forEach((row) => {
          categoryList.push({
            id: row.id,
            label: row.name,
            value: row.name,
            path: `${getImage(row.logoView)}`,
          });
          setServiceProviderOptionList(categoryList);
        });
      }
    });
  };

  useEffect(() => {
    getServiceProviderDropDownList();
  }, []);

  const [notificationList, setNotificationList] = useState([]);
  const [currentNotification, setCurrentNotification] = useState();

  function notificationView() {
    const data = {};
    const params = {
      start: itemOffset,
      recordSize: rowsPerPage,
    };

    if (!isEmpty(serviceProvider)) {
      data.serviceProviderView = {
        id: serviceProvider.id
      };
    }

    notificationListView(data, params).then((res) => {
      setNotificationList(res.list);
      setListRecordSize(res.records);
    });
  }
  useEffect(() => {
    notificationView();
  }, [itemOffset, rowsPerPage, serviceProvider]);

  // delete notification
  const [open, setOpen] = useState(false);

  const handleDeleteNotification = () => {
    deleteNotification({ id: currentNotification }).then((res) => {
      if (res.hasError === false) {
        setOpen(false);
        dispatch(notifySet({ type: 'success', message: res.message }));
        notificationView();
      } else if (res.hasError === true) {
        dispatch(notifySet({ type: 'error', message: res.message }));
      }
    });
  };

  // broadcast

  const [openBroadcast, setOpenBroadcast] = useState(false);

  const handleBroadCast = () => {
    broadcastNotification({ eventId: currentNotification }).then((res) => {
      if (res.hasError === false) {
        setOpenBroadcast(false);
        dispatch(notifySet({ type: 'success', message: res.message }));
        notificationView();
      } else if (res.hasError === true) {
        dispatch(notifySet({ type: 'error', message: res.message }));
      }
    });
  };

  return (
    <div>
      <div className="title-con">
        <div className="row align-items-center">
          <div className="col-sm-12 col-md-12 col-lg-5">
            <div className="title-left-con">
              <h6>Notification List</h6>
            </div>
          </div>
          <div className="col-sm-12 col-md-12 col-lg-7">
            <div className="title-right-con list-ul-con">
              <ul>
                <li style={{ minWidth: '200px' }}>
                  <Select
                    options={serviceProviderOptionList} // eslint-disable-next-line
                    value={serviceProvider}
                    onChange={(value) => setServiceProvider(value)}
                    placeholder="Service Partner"
                    isClearable="true"
                  />
                </li>
                <li>
                  <Link
                    className="addcircle"
                    to="/add-notification"
                  >
                    <AiOutlinePlus />
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      {isEmpty(notificationList) && <p className="text-center" style={{ marginTop: '100px' }}>No notification found</p> }
      {!isEmpty(notificationList) && (
        <div>
          <Paper sx={{ overflow: 'hidden', marginTop: '30px' }}>
            <TableContainer
              component={Paper}
              className="tableContainer"
              sx={{ maxHeight: 720, marginRight: 'auto' }}
            >
              <Table stickyHeader className={classes.root}>
                <TableHead>
                  <TableRow>
                    <TableCell width={60}>No.</TableCell>
                    <TableCell width={150}>Service Partner</TableCell>
                    <TableCell>Description</TableCell>
                    <TableCell width={200}>Event Date</TableCell>
                    <TableCell width={80}>Status</TableCell>
                    <TableCell width={130}>Actions</TableCell>
                    <TableCell width={150}>Broadcast</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {notificationList.map((notificationData, key) => (
                    <TableRow
                      key={key}
                      hover
                      tabIndex={-1}
                      className="muiTableRow"
                    >
                      <TableCell>{key + 1 + itemOffset}</TableCell>
                      <TableCell>
                        {notificationData.serviceProviderView.name}
                      </TableCell>
                      <TableCell>{notificationData.description}</TableCell>
                      <TableCell>{fromEpochToDate(notificationData.endDate)}</TableCell>
                      <TableCell>
                        <Toggler notificationData={notificationData} />
                      </TableCell>
                      <TableCell>
                        <Tooltip title={notificationData.isBroadcast ? 'broadcasted' : 'Edit'}>
                          <Link to={notificationData.isBroadcast ? '#' : `/edit-notification/${notificationData.id}`}>
                            <FaEdit
                              style={{
                                color: notificationData.isBroadcast ? 'red' : 'black',
                                fontSize: '20px',
                                cursor: notificationData.isBroadcast ? 'not-allowed' : 'default',
                              }}
                            />
                          </Link>
                        </Tooltip>
                        <Tooltip title="Delete">
                          <span>
                            <MdDelete
                              style={{ marginLeft: '15px', fontSize: '25px' }}
                              onClick={() => {
                                setCurrentNotification(notificationData.id);
                                setOpen(true);
                              }}
                            />
                          </span>
                        </Tooltip>
                      </TableCell>
                      <TableCell>
                        <Tooltip title={notificationData.isBroadcast ? 'broadcasted' : 'broadcast'}>
                          <span>
                            <RiBroadcastFill
                              style={{
                                fontSize: '25px',
                                marginLeft: '15px',
                                color: notificationData.isBroadcast ? 'red' : 'black',
                                cursor: notificationData.isBroadcast ? 'not-allowed' : 'default',
                              }}
                              onClick={
                                notificationData.isBroadcast
                                  ? () => {}
                                  : () => {
                                    setCurrentNotification(notificationData.id);
                                    setOpenBroadcast(true);
                                  }
                              }
                            />
                          </span>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[5, 10, 20]}
              component="div"
              count={listRecordSize}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={onPageChange}
              onRowsPerPageChange={handleChangeRowsPerPage}
              className="tablepaginationcon"
            />
          </Paper>
        </div>
      )}
      <div>
        <Modal
          open={open}
          onOk={() => handleDeleteNotification()}
          onCancel={() => setOpen(false)}
          okText="Delete"
        >
          Are you sure you want to Delete?
        </Modal>
        <Modal
          open={openBroadcast}
          onOk={() => handleBroadCast()}
          onCancel={() => setOpenBroadcast(false)}
          okText="Broadcast"
        >
          Are you sure you want to Broadcast?
        </Modal>
      </div>
    </div>
  );
}

export default NotificationList;
